import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCreateOrderMutation } from "../services/appApi";
import { toast } from "react-toastify";
import { url } from "../db/url";

function CheckoutForm({ total }) {
  const stripe = useStripe();
  const elements = useElements();
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState("");
  const [createOrder, { isLoading, isError, isSuccess }] = useCreateOrderMutation();
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const [paying, setPaying] = useState(false);

  async function handlePay(e) {
    e.preventDefault();
    if (!stripe || !elements) return;
    setPaying(true);

    
    const response = await fetch(`${url}/api/v2/payment/process`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer ",
    },
      body: JSON.stringify({ amount: total }),
    });

    if (!response.ok) {
      
      console.error("Payment intent request failed");
      return;
    }

  

    const { client_secret } = await response.json();

  
    console.log("Request Data:", { amount: total });

    const { paymentIntent } = await stripe.confirmCardPayment(client_secret, {
      payment_method: {
        card: elements.getElement(CardElement),
      },
    });
    setPaying(false);

    
    console.log("PaymentIntent Response:", paymentIntent);
    toast.success("Payment successfully!!!")

    if (paymentIntent) {
      navigate('/dashboard/orders')
      localStorage.removeItem('cart')

      // createOrder({ userId: user._id, cart: user.cart, address, country }).then(
      //   (res) => {
      //     if (!isLoading && !isError) {
      //       setAlertMessage(`Payment ${paymentIntent.status}`);
      //       setTimeout(() => {
          
      //       }, 3000);
      //     }
      //   }
      // );
    }
  }

  return (
    <form onSubmit={handlePay}>
      <h2>Delivery Information</h2>
      <div className="inputContainer">
        <div className="inputWrapper">
          <label htmlFor="">First Name</label>
          <input type="text" name="" id="" placeholder="John" />
        </div>
        <div className="inputWrapper">
          <label htmlFor="">Last Name</label>
          <input type="text" name="" id="" placeholder="Doe" />
        </div>
      </div>
      <div className="inputContainer">
        <div className="inputWrapper">
          <label htmlFor="">Email Address:</label>
          <input type="email" name="" id="" placeholder="agc@example.com" />
        </div>
        <div className="inputWrapper">
          <label htmlFor="">Phone Number:</label>
          <input type="text" name="" id="" placeholder="08023456789" />
        </div>
      </div>
      <div className="inputWrapper">
        <label htmlFor="">Delivery Address:</label>
        <input
          type="text"
          onChange={(e) => setAddress(e.target.value)}
          required
          name=""
          id=""
          placeholder="Street Number, Address, Apartment/suite floor"
        />
      </div>

      <div className="inputWrapper">
        <label htmlFor="">Country/State:</label>
        <input
          type="text"
          name=""
          id=""
          placeholder="Rivers State, Nigeria"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          required
        />
      </div>
      <div className="inputWrapper">
        <label htmlFor="card-element">Card</label>
        <CardElement id="card-element" />
      </div>
      <div className="inputWrapper">
      <button className="mt-3 bg-green-700" type="submit" disabled={ paying || isSuccess}>
                    {paying ? "Processing..." : "Pay"}
                </button>
      </div>
    </form>
  );
}

export default CheckoutForm;
